import React from "react";
import {
  calculateDaysSinceLastLogin,
  getMobileAppStatus,
} from "../../utils/helpers";
import PhoneStatusIcon from "../../icons/PhoneStatusIcon";

const MobileAppStatusIcon = ({
  enrolments,
  enrollment_status,
  creation_flow,
  ever_logged_in,
  ever_logged_pain,
  last_reading,
}) => {
  const days_since_last_login = calculateDaysSinceLastLogin(last_reading);

  //   console.log("ZZZZ", ever_logged_in, last_reading);

  const status = getMobileAppStatus({
    enrolments,
    enrollment_status,
    creation_flow,
    ever_logged_in,
    ever_logged_pain,
    days_since_last_login,
  });

  return <PhoneStatusIcon color={status?.icon} />;
};

export default MobileAppStatusIcon;
